import React from 'react';
import {Link} from 'react-router-dom'
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import indigo from "@material-ui/core/colors/indigo";
import Utility from "../../Utility";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    button: {
        margin: theme.spacing.unit,
        width: '80%'
    },
    menu :{
        backgroundColor: indigo[50],
    }
});

const applicationMenuArray = [
    [
        // {
        //     "to": "/registerUser",
        //     "label": "ユーザー登録"
        // }
    ],
    [
        {
            "to": "/setNonDispatchableNum",
            "label": "貸出不可台数の設定"
        },
        {
            "to": "/dispatchRequestList",
            "label": "配車要求の承認と却下"
        },
        {
            "to": "/cancelRequestList",
            "label": "キャンセル要求承認"
        }
    ],
    [
        {
            "to": "/selectPompSpec",
            "label": "配車要求申請"
        },
        {
            "to": "/dispatchRequestList",
            "label": "配車要求確認"
        },
        {
            "to": "/cancelRequestList",
            "label": "キャンセル要求確認"
        }
    ]
];

const plantManagementMenuArray = [
    {
        "to": "/uploadCsv",
        "label": "工事計画CSVアップロード"
    },
    {
        "to": "/downloadCsv",
        "label": "工事計画CSVダウンロード"
    },
    {
        "to": "/deleteCsv",
        "label": "工事計画CSV削除"
    }
];

const plantManagementMenuSelectCsv = {
    "to": "/selectCsv",
    "label": "現場選択"
};

// const myMenuArray = [
//     {
//         "to": "/editUserInfo",
//         "label": "ユーザー情報編集"
//     }
// ];

function createLinkButton(path, key, className, label){
    const ButtonLink = props => <Link to={path} {...props} />;
    return (
        <div key={key}>
            <Button className={className} component={ButtonLink} variant="contained" color="primary">{label}</Button>
        </div>
    )
}

export class Top extends React.Component {
    constructor(props){
        super(props);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('トップ画面');
        }
    }

    render(){
        let userRoleIndex = this.props.cookies.get('role');
        return (
            <div className={this.props.classes.root}>
                <div>
                    <h3 className={this.props.classes.menu}>ジェット配車 機能メニュー</h3>
                    {
                        applicationMenuArray[userRoleIndex].map((row, i) =>{
                            return createLinkButton(row.to, i, this.props.classes.button, row.label);
                        })
                    }
                </div>
                <div>
                <h3 className={this.props.classes.menu}>洗浄場管理 機能メニュー</h3>
                </div>
                {Utility.isKecRole(userRoleIndex) && (
                <>
                    {plantManagementMenuArray.map((row, i) => {
                                return createLinkButton(row.to, i, this.props.classes.button, row.label);
                                })}
                <hr width="100%" size="1" color="black" noshade="true" />
                </>
                )}
                {createLinkButton(plantManagementMenuSelectCsv.to, 0, this.props.classes.button, plantManagementMenuSelectCsv.label)}

                {/*<div>*/}
                {/*<h3 className={this.props.classes.menu}>マイメニュー</h3>*/}
                {/*{*/}
                {/*myMenuArray.map((row, i) =>{*/}
                {/*return createLinkButton(row.to, i, this.props.classes.button, row.label);*/}
                {/*})*/}
                {/*}*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default withStyles(styles)(Top);
